import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "shared/components/Modal";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/api/graphql/queries/screens";
import { SCREENS as ROUTES } from "utils/constants";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(ROUTES.PRIVATE.ADMIN.SCREEN_STUDIOS.LIST.path);

  const [deleteScreen] = useMutation(graphql.mutations.DELETE_SCREEN, {
    refetchQueries: [{ query: SCREENS, awaitRefetchQueries: true }],
    onCompleted: () => {
      setVisible(false);
      navigate(ROUTES.PRIVATE.ADMIN.SCREEN_STUDIOS.LIST.path, { replace: true });
    },
  });

  return (
    <Modal
      okText="Supprimer"
      cancelText="Annuler"
      onCancel={cancel}
      onOk={() => deleteScreen({ variables: { where: { id } } })}
      message="Êtes-vous sûr de vouloir supprimer cet écran ?"
      visible={visible}
    />
  );
};

export default Delete;
